import React, { PropsWithChildren } from 'react';

export const HeaderItem = ({ children }: PropsWithChildren<{}>): JSX.Element => (
  <div className="l-header__column">{children}</div>
);
